import { PipeTransform } from '@angular/core';
var PercentageDecreaseAndIncreasePipe = /** @class */ (function () {
    function PercentageDecreaseAndIncreasePipe() {
    }
    PercentageDecreaseAndIncreasePipe.prototype.transform = function (previousValue, currentValue) {
        if (previousValue === 0 || currentValue === 0) {
            return 1;
        }
        var value = currentValue >= previousValue
            ? Math.abs(Number((currentValue - previousValue) / previousValue))
            : Math.abs(Number((currentValue - previousValue) / currentValue));
        return value.toFixed(4) || 0;
    };
    return PercentageDecreaseAndIncreasePipe;
}());
export { PercentageDecreaseAndIncreasePipe };
